import UploadGrades from './UploadGrades';

export default UploadGrades;
